module.exports = __webpack_public_path__ + "static/media/Niveau_elN1_3_544638.6fd41416.png";